// extracted by mini-css-extract-plugin
export default {"table":"cA0QLr5N","tableContent":"q0pULk7J","tableRow":"LmstU0Z6","tableCell":"K3WhAau2","description":"At_RrLoU"};
    if(module.hot) {
      // 1712151479855
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  